import { render, staticRenderFns } from "./vas.vue?vue&type=template&id=e8f31638&scoped=true&"
import script from "./vas.vue?vue&type=script&lang=js&"
export * from "./vas.vue?vue&type=script&lang=js&"
import style0 from "./vas.vue?vue&type=style&index=0&id=e8f31638&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8f31638",
  null
  
)

component.options.__file = "vas.vue"
export default component.exports